var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSend = function SvgSend(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "m19.334 6.08-7.666 7.666 2.333 6zm-9.08 6.252 7.666-7.666L4.254 9.998zM20.647 1.473c.183-.053.552-.149.948-.016.447.149.798.5.947.947.132.396.037.764-.017.947-.058.2-.15.438-.244.677l-6.617 16.957a10 10 0 0 1-.304.724c-.085.173-.274.54-.668.744a1.5 1.5 0 0 1-1.385-.001c-.393-.205-.582-.572-.667-.744-.099-.2-.2-.458-.303-.725l-2.61-6.712-6.676-2.596-.035-.013c-.267-.104-.526-.205-.725-.303-.173-.085-.54-.274-.744-.668a1.5 1.5 0 0 1-.001-1.384c.204-.394.57-.584.743-.669.2-.098.458-.2.725-.303l.035-.014 16.922-6.604c.239-.093.477-.186.676-.244",
    clipRule: "evenodd"
  })));
};
export default SvgSend;